<template>
  <div>
    <div class="mask"></div>
    <div class="loading"></div>
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  }
}
</script>

<style lang="less" scoped>
  .mask {
    position: fixed;
    right: 0;
    top: 0;
    bottom: 0;
    left: 0;
    background: #000000;
    z-index: 10000;
    opacity:0.5;
  }
  .loading{
    position: fixed;
    top: 50%;
    left: 50%;
    margin: -1.25rem 0 0 -1.25rem;
    width: 2.5rem;
    height: 2.5rem;
    border: 2px solid;
    border-color: #fff #fff transparent;
    border-radius: 50%;
    box-sizing: border-box;
    background: none;
    animation: loading 1s linear infinite;
    z-index: 10001;
  }
  @keyframes loading{
    0%{
      transform: rotate(0deg);
    }
    100%{
      transform: rotate(360deg);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/loading.vue